// extracted by mini-css-extract-plugin
module.exports = {"imgWrapper":"WrappedImage-module--imgWrapper--1M8tz","img":"WrappedImage-module--img--2vzOS"};